import superMeta from '../_COMMENT/metaCommentNode.mjs'

export default {
    ...superMeta,
    name: '模件组别',
    type: 'CAT',
}
